import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import FormField from './FormField';
import FormGroup from './FormGroup';

export default class TextInput extends FormField {
  get pattern() {
    switch (this.props.type) {
      case 'text':
        return /([^\s])/;
      case 'email':
        return /^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,6}$/;
      case 'number':
        return /^\d+$/;
      case 'color':
        return /^#([0-9a-f]{6}|[0-9a-f]{3})$/i;
      case 'password':
        return /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
      case 'tel':
        return /^\+?\d+[\d\s-]*\d+\W*$/;
      case 'url':
        return /^(ftp|http|https):\/\/[^ "]+$/;
      case 'date':
        return /^\d{4}-\d{2}-\d{2}$/;
      default:
        return /([^\s])/;
    }
  }

  render() {
    const { error, checked } = this.state;
    const inputProps = _.omit(this.props, 'onValidate');
    return (
      <FormGroup {...this.props}>
        <input
          {...inputProps}
          className={classNames('form-group-input', { error, checked })}
          type={this.props.type}
          onChange={this.onChange}
          onBlur={this.onBlur}
          value={this.props.value}
        />
      </FormGroup>
    );
  }
}

TextInput.propTypes = {
  ...FormField.propTypes,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.oneOf('text email number color password tel url date'.split(' ')),
};

TextInput.defaultProps = {
  type: 'text',
};
